import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    mainColor:'#80CBC4',
    mainColorDarken:'#008080'
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
